import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

import AllUniformAddPopup from "../../../../components/modelpopup/AllUniformAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import UniformListFilter from "../components/UniformListFilter";
import { Table, Pagination,  } from "antd";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import {formatDateHandler2} from "utils/common"

import { SkeltonLoader } from "components/skeltonLoader";
import UniformsFilterDrawer from "components/Drawer/uniformsFilterDrawer";
import { useUniform } from "../context/uniformContext";
import Image from "components/Image"
import {  toast, Bounce } from 'react-toastify';

//import { deleteUniformApi } from "api/services/uniforms";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";

import FilterSelect from "components/Form/filterSelect"
import { getEmployeesApi } from "api/services/employee";
import { uniformAllocation, getUniformsApi } from "api/services/uniforms";
import { Button } from "components/Button";

const AssignUniform = () => {

    const {
      department, departmentLoading,
      costCenter, costCenterLoading,
      position, positionLoading,

    userData, userDataLoading
   
} = useSelector((state) => state.common);



  const {
    loading,
    setLoading,
    searchText,
    uniformData,
    view,
    setView, 
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleUniformDetailPage,
    handleDateChange,
    createUniformHandler,
    uniformModal, setUniformModal,
    setSelectedUniform, selectedUniform,
    
    
  } = useUniform();


  





  
  const [positionOption, setPositionOption] = useState([]);

  const [uniforms, setUniforms] = useState([]);

  const [uniformSearch, setUniformSearch] = useState("");
  const [employeeSearch, setEmployeeSearch] = useState("");


  const [employees, setEmployees] = useState([]);
  const [costCenterOption, setCostCenterOption] = useState([]);
  const [employeesLoading, setEmployeesLoading] = useState(false);
  const [selectedCostCenter, setSelectedCostCenter] = useState("");
  const [selectedPos, setSelectedPos] = useState("");
  const [uniformLoading,setUniformLoading]= useState(false);


  // useEffect(()=>{
   
  //   if(userData){
  //     let users = userData.map(item=> {
  //       return{
  //           id: `${item.id}`,
  //           name: `${item.first_name} ${item.last_name}`,
  //           uniforms:[]
  //       }
  //   })
  //   setEmployees(users)
  //   }
  
  
  // },[userData])

  useEffect(()=>{
    if(selectedPos?.value){
      getEmployeeList()
      getUniformList()

    }
  },[selectedPos, selectedCostCenter])
  

  // useEffect(()=>{
  //   let un = uniformData.map(item=> {
  //       return{
  //           id: item.id.toString(),
  //           name: item.name,
  //           image: item.image
  //       }
  //   })
  //   setUniforms(un)
  // },[uniformData])





  const getEmployeeList = () => {

    
    setEmployeesLoading(true)
    getEmployeesApi({
      page_size: 3000,
      page: 1,
      position: selectedPos?.value,
      cost_center: selectedCostCenter?.value || ""
  
    }).then(response=>{
      setEmployeesLoading(false)

          setEmployees(response.data.results);
      
  
        }).catch(e=>{
  
        })
      }

      const getUniformList = () => {

    
        setUniformLoading(true)
        getUniformsApi({
          // page_size: 3000,
          // page: 1,
          position: selectedPos?.value
      
        }).then(response=>{
          setUniformLoading(false)
    
              setUniforms(response.data);
          
      
            }).catch(e=>{
      
            })
          }

          
      
  const filteredUniforms = uniforms.filter((uniform) =>
  uniform.name.toLowerCase().includes(uniformSearch.toLowerCase())
);


const filteredEmployees = useMemo(()=>{
  let filtered = employees.filter(employee=>
 
    {
      const searchMatch = !employeeSearch ||
        employee.first_name?.toLowerCase().includes(employeeSearch.toLowerCase()) ||
        employee.last_name?.toLowerCase().includes(employeeSearch.toLowerCase()) ||
        employee.emp_no?.toLowerCase().includes(employeeSearch.toLowerCase());

        const positionMatch =
        !selectedPos?.value || employee.employment?.position?.id === selectedPos?.value;
      // const costCenterMatch =
      //   !selectedCostCenter || employee.costCenter === selectedCostCenter;
      return searchMatch && positionMatch;

    }
   
  )
  return filtered
},[selectedCostCenter, selectedPos, employeeSearch, employees])
// const filteredEmployees = employees.filter((employee) =>
//   employee.first_name?.toLowerCase().includes(employeeSearch.toLowerCase()) || employee.last_name?.toLowerCase().includes(employeeSearch.toLowerCase()) || employee.emp_no?.toLowerCase().includes(employeeSearch.toLowerCase())
// );


const [selectedUniforms, setSelectedUniforms] = useState([]);
const [selectedEmployees, setSelectedEmployees] = useState([]);
const [step, setStep] = useState(1);
const [quantity, setQuantity] = useState({});
const [size, setSize] = useState({});
const [allocationDate, setAllocationDate] = useState(null);

const handleUniformSelection = (id) => {
  setSelectedUniforms((prev) =>
    prev.includes(id) ? prev.filter((uId) => uId !== id) : [...prev, id]
  );
};

const handleEmployeeSelection = (id) => {
  setSelectedEmployees((prev) =>
    prev.includes(id) ? prev.filter((eId) => eId !== id) : [...prev, id]
  );
};

const handleSizeChange = (id, value) => {
  setSize((prev) => ({
    ...prev,
    [id]: value ? parseInt(value) : null,
  }));
};
const handleQuantityChange = (id, value) => {
  setQuantity((prev) => ({
    ...prev,
    [id]: Math.max(1, (prev[id] || 1) + value),
  }));
};

// const handleSubmit = () => {
//   const allocationDetails = selectedEmployees.map((employeeId) => ({
//     employeeId,
//     uniforms: selectedUniforms.map((uniformId) => ({
//       uniformId,
//       quantity: quantity[uniformId] || 1,
//     })),
//     allocationDate,
//   }));

//   console.log("Allocation Details:", allocationDetails);
//   alert("Uniforms allocated successfully!");

// };


useEffect(()=>{

  let _positions = position.map(item=> {
      return{
          label: item.name,
          value: item.id
      }
  })

  let cost_center = costCenter.map(item=> {
    return{
        label: item.code,
        value: item.id
    }
})
  setPositionOption(_positions)

  setCostCenterOption(cost_center)
},[ costCenter, position])

const handleSubmit = () => {
  // Validate allocation date is provided
  if (!allocationDate) {
    toast.error('Allocation Date is required!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
    return;
  }

  // Validate that all uniforms with sizes have a size selected
  const uniformsWithSizes = selectedUniforms.filter(uniformId => {
    const uniform = uniforms.find((u) => u.id === uniformId);
    return uniform?.sizes && uniform.sizes.length > 0;
  });

  const missingSizes = uniformsWithSizes.filter(uniformId => !size[uniformId]);
  
  if (missingSizes.length > 0) {
    toast.error('Please select size for all uniforms that require it!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
    return;
  }

  const result = selectedUniforms.map((uniformId) => ({
    uniform_id: uniformId,
    company_users: selectedEmployees,
    quantity: selectedEmployees.length > 0 ? quantity[uniformId]||1 : 1,
    size: selectedEmployees.length > 0 ? size[uniformId]||null: null,
    allocation_date: selectedEmployees.length > 0 ? allocationDate ||null: null,
    status: "initiated",
  }));

  console.log(result); // Log the resulting array

  uniformAllocation(result).then(response=>{

    // Reset after submission
    setSelectedUniforms([]);
    setSelectedEmployees([]);
    setStep(1);
    setQuantity({});
    setSize({});
    setAllocationDate("");

    toast.success('Uniform Allocated!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
      });


  }).catch(err=>{
    toast.error(err.response?.data?.error||'Error in allocating uniform!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
      });
  })
  // alert("Allocation Data Submitted! Check Console for Details.");

    
};
const handleBack = () => {
  // no need to reset the selected uniforms and employees on back button 14-oct change
  // setSelectedUniforms([]);
  // setSelectedEmployees([]);
  setStep(1);
  // setQuantity({});
  // setSize({});
  // setAllocationDate("");
}


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
     
        
          <Breadcrumbs
           maintitle="Uniforms"
           title="Dashboard"
           subtitle="Uniforms"
           modal="#add_uniform"
           name="Assign Uniform"
           view={view}
           setUniformModal={setUniformModal}
           setView={setView}  
          />


    <div className="container mt-4">
      <div className="col-md-4 mb-4">
      <h4 className="mb-1" >Select a position</h4>
      <FilterSelect isClearable={true}  
 optionLabel={"label"} optionValue={'value'} 
  options={positionOption} isLoading={positionLoading} 
  onChange={e=>{
    setSelectedPos(e)
  }}

  placeholder={"Select Position"}/> 

      </div>
      {
        selectedPos &&
        <div className="row">
        {/* Uniforms Column */}
        <div className="col-6">
          <h2>Uniforms</h2>
          <br/>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search Uniforms"
            value={uniformSearch}
            onChange={(e) => setUniformSearch(e.target.value)}
          />
          <div
            className="p-3 border bg-light"
            style={{
              maxHeight: "450px",
              overflowY: "scroll",
            }}
          >
          
            {
                !filteredUniforms.length &&
                <h3>No uniforms available</h3>
              }
                  {filteredUniforms.map((uniform, index) => (
                    
                        <div
                         
                          className="p-2 mb-2 bg-white border rounded d-flex align-items-center"
                        >
                            <input
                          type="checkbox"
                          className="form-check-input me-2"
                          id={`uniform-${uniform.id}`}
                          checked={selectedUniforms.includes(uniform.id)}
                          onChange={() => handleUniformSelection(uniform.id)}
                        />
                        <Image className="me-2" src={uniform.image} type="lll"  style={{ width: "25px", height: "25px", objectFit: "contain" }}/>

                        
                          {uniform.name}
                        </div>
                     
                  ))}
         
          </div>
        </div>

        {/* Employees Column */}
        <div className="col-6">
          <h2>Employees</h2>
          <br/>
          <div className="row mb-2" >
          <div className="col-6">
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search Employees"
            value={employeeSearch}
            onChange={(e) => setEmployeeSearch(e.target.value)}
          />
          {/* <FilterSelect  isClearable={true} 
           optionLabel={"label"} optionValue={'value'} 
           options={costCenterOption}  
          //  value={setFilterValue("cost_center")} 
           placeholder={"Cost Center"}
            isLoading={costCenterLoading}
            onChange={e=>{
              console.log(e, "EEEE")
              setSelectedCostCenter(e)
            }}
            /> */}
            </div>
            <div className="col-6">
            <FilterSelect  isClearable={true} 
           optionLabel={"label"} optionValue={'value'} 
           options={costCenterOption}  
          //  value={setFilterValue("cost_center")} 
           placeholder={"Cost Center"}
            isLoading={costCenterLoading}
            onChange={e=>{
              console.log(e, "EEEE")
              setSelectedCostCenter(e)
            }}
            /> 
            {/* <FilterSelect isClearable={true}  
 optionLabel={"label"} optionValue={'value'} 
  options={positionOption} isLoading={departmentLoading} 
  onChange={e=>{
    setSelectedPos(e)
  }}

  placeholder={"Department"}/> */}
            </div>
          </div>
         


 
          
          {step === 1 && (
            <div
              className="p-3 border bg-light"
              style={{
                maxHeight: "450px",
                overflowY: "scroll",
              }}
            >
              {
                !filteredEmployees.length &&
                <h3>No employees available</h3>
              }
              {filteredEmployees.map((employee) => (
                <div
                         
                className="p-2 mb-2 bg-white border rounded d-flex align-items-center"
              >
                  <input
                type="checkbox"
                className="form-check-input me-2"
                id={`uniform-${employee.id}`}
                checked={selectedEmployees.includes(employee.id)}
                    onChange={() => handleEmployeeSelection(employee.id)}
              />

              <div className="d-flex flex-column" >
              <label  className="">
            {employee.first_name} {employee.last_name}
          </label>
          <span className="text-sm" style={{fontSize:10}} >{employee.emp_no}</span>
              {/* <label
                    className="form-check-label"
                    htmlFor={`employee-${employee.id}`}
                  >
                   {employee.first_name + " " + employee.last_name} 
                  </label>
                  <span>{employee.emp_no}</span> */}

              </div>
                  
              </div>
                // <div key={employee.id} className="form-check mb-2">
                //   <input
                //     type="checkbox"
                //     className="form-check-input"
                //     id={`employee-${employee.id}`}
                //     checked={selectedEmployees.includes(employee.id)}
                //     onChange={() => handleEmployeeSelection(employee.id)}
                //   />
                //   <label
                //     className="form-check-label"
                //     htmlFor={`employee-${employee.id}`}
                //   >
                //   {employee.emp_no} &nbsp;  {employee.first_name + " " + employee.last_name} 
                //   </label>
                // </div>
              ))}
            </div>
          )}

          {step === 2 && (
            <div className="p-3 border bg-light">
              <h4>Allocate Uniforms</h4>
              <div className="mb-3 d-flex justify-content-between">
                <div className="col-6 d-flex align-items-center" >
                <label className="form-label mb-0">Allocation Date <span className="text-danger">*</span></label>

                </div>
                <input
                  type="date"
                  className="form-control"
                  value={allocationDate}
                  onChange={(e) => setAllocationDate(e.target.value)}
                  required
                />
              </div>
              {selectedUniforms.map((uniformId) => {
                const uniform = uniforms.find((u) => u.id === uniformId);
                const hasSizes = uniform.sizes && uniform.sizes.length > 0;
                const sizeOrder = ["XS", "S", "M", "L", "XL", "XXL"];
                const sortedSizes = hasSizes 
                  ? [...uniform.sizes].sort((a, b) => 
                      sizeOrder.indexOf(a.code) - sizeOrder.indexOf(b.code)
                    )
                  : [];

                return (
                  <div
                    key={uniformId}
                    className="mb-3 d-flex align-items-center"
                  >
                    <div className="col-6 d-flex align-items-center" >
                    <span className="me-3">{uniform.name}</span>
                    </div>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => handleQuantityChange(uniformId, -1)}
                    >
                      -
                    </button>
                    <span className="mx-2">{quantity[uniformId] || 1}</span>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => handleQuantityChange(uniformId, 1)}
                    >
                      +
                    </button>
                    {hasSizes && (
                      <select
                        className="form-control ms-4"
                        value={size[uniformId] || ""}
                        style={{height:35}}
                        onChange={(e) => handleSizeChange(uniformId, e.target.value)}
                        required
                      >
                        <option value="">Select Size *</option>
                        {sortedSizes.map((sizeItem) => (
                          <option key={sizeItem.id} value={sizeItem.id}>
                            {sizeItem.name} ({sizeItem.code})
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                );
              })}
              <Button label="Submit"  className="btn btn-primary "    onClick={handleSubmit}>
                Submit
              </Button>

              <Button label="Back"  className="btn btn-secondary ms-3" onClick={handleBack}>
                Back
              </Button>
            </div>
          )}
          {step === 1 && (
            <div className="mt-3">
              <button
                className="btn btn-primary"
                onClick={() => setStep(2)}
                disabled={
                  selectedUniforms.length === 0 || selectedEmployees.length === 0
                }
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
      }
     
    </div>
        </div>
      </div>

  
    

    </>
  );
};

export default AssignUniform;
